@if (isDesktop && data.showCancel) {
  <div class="flex flex-col py-2 mb-4">
    @if (isDesktop) {
      <div class="flex flex-row items-center px-4 justify-between">
        <div class="text-neutral-900 text-2xl font-semibold leading-[32px]">
          {{ 'catalog.title1' | translate }}
        </div>
        <button
          [mat-dialog-close]="null"
          dsw-medium-icon-button="none"
          dswSuffix
          mat-icon-button
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
  </div>
} @else {
  @if (data.showCancel) {
    <div class="flex flex-col" mat-dialog-title>
      <div class="flex flex-row items-center px-4 justify-start">
        <button [mat-dialog-close]="null" mat-button>
          <mat-icon>arrow_back</mat-icon>
          <span>{{ 'common.back' | translate }}</span>
        </button>
      </div>
    </div>
  }
}


<div class="grow flex-col flex" mat-dialog-content cdkFocusInitial>
  <et-catalog-switcher
    (selectCatalog)="onSelectCatalog($event)"
    (cancelClicked)="onClose()"
    [currentCatalog]="data.currentCatalog"
    [salesOrgs]="data.salesOrgs"
    [saveButtonLabel]="data.saveButtonLabel"
  ></et-catalog-switcher>
</div>
